import { useMemo } from "react"
import type { DuplicateViewFlowActions } from "connected-components/asset-view/helpers/duplicate-view-flow"
import { useGraphData } from "./use-graph-data"

export function useGraphDuplicateFlow(): DuplicateViewFlowActions {
  const {
    setSelectedTemplate,
    setShowMetricsSelector,
    setDuplicateFromViewName,
    setDuplicateFromTemplateId,
    setDuplicateFromViewMetrics,
    setDuplicateReturnViewId,
    clearDuplicateState,
  } = useGraphData()

  return useMemo(() => ({
    setView: setSelectedTemplate,
    setShowMetricsSelector,
    setDuplicateFromViewName,
    setDuplicateFromTemplateId,
    setDuplicateFromViewMetrics,
    setDuplicateReturnViewId,
    clearDuplicateState,
  }), [
    setSelectedTemplate,
    setShowMetricsSelector,
    setDuplicateFromViewName,
    setDuplicateFromTemplateId,
    setDuplicateFromViewMetrics,
    setDuplicateReturnViewId,
    clearDuplicateState,
  ])
}
